import {BaseModel} from "sjs-base-model";

export default class UserModel extends BaseModel {
    public userId: string = '';
    public name: string = '';
    public surname: string = '';
    public email: string = '';
    public createDate: string = '';
    public expiryDate: string = '';
    public userStatus: string = '';
    public apiKeyStatus: string = '';
    public provider: string = '';
    public eexUserId: string = '';
    public company: string = '';
    public roles:string[] = [];

    constructor(data: Partial<UserModel>) {
        super();
        this.update({
            userId: data.userId,
            name: data.name,
            surname: data.surname,
            email: data.email,
            createDate: data.createDate,
            expiryDate: data.expiryDate,
            userStatus: data.userStatus,
            apiKeyStatus: data.apiKeyStatus,
            provider: data.provider,
            eexUserId: data.eexUserId,
            company: data.company,
            roles: data.roles || [],
        });
    }
}